export default "__VITE_ASSET__Dk70KRr6__"